import React from 'react'
import RadioGroup, {RadioGroupProps} from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import FormControl from '@mui/material/FormControl'
import styled from 'styled-components'
import button_notify_prefsStyles from './button_notify_prefs.styles'
import PhoneNumberAtom from '../phone_number/phone_number.atom'
import EmailAtom from '../email_field/email_field.atom'

const StyledWrapper = styled.div`
  ${button_notify_prefsStyles}
`

const apAtomName = {ap_atom_name: 'buttonNotifyPrefsAtom'}

// TODO
// interface NotificationProps {
//   type: 'phone' | 'email'
//   value: string
// }

const ButtonNotifyPrefsAtom = function (props: RadioGroupProps) {
  // const [selected, setSelected] = useState<NotificationProps>()

  return (
    <StyledWrapper>
      <FormControl {...apAtomName}>
        <RadioGroup
          aria-labelledby="notify-prefs"
          defaultValue="email"
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="email"
            control={<Radio />}
            label={<EmailAtom />}
          />
          <FormControlLabel
            value="phone"
            control={<Radio />}
            label={<PhoneNumberAtom />}
          />
        </RadioGroup>
      </FormControl>
    </StyledWrapper>
  )
}
export default ButtonNotifyPrefsAtom
